/* eslint-disable redux-saga/no-unhandled-errors */
import type { AxiosResponse } from 'axios';
import { call, delay, put, race, take, takeLatest } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';
import type { ActionType } from 'typesafe-actions';

import { client } from '@portal/api-client/src/client';
import type { Notification } from '@portal/api-models';
import { getPortalError } from '@portal/common';

import * as actions from './actions';

export function* getAllNotifications() {
  try {
    const { data: response }: AxiosResponse<Notification[]> = yield call(
      [client, 'get'],
      '/notifications'
    );

    yield put(actions.notificationsRequestAction.success(response));
  } catch (err: any) {
    yield put(actions.notificationsRequestAction.failure(err));
  }
}

export function* notificationsPollingWorker() {
  while (true) {
    yield delay(30e3);
    yield put(actions.notificationsRequestAction.request({}));
  }
}

export function* notificationWatchWorker() {
  yield race({
    cancel: take(getType(actions.stopPollingNofications)),
    task: call(notificationsPollingWorker),
  });
}

export function* updateNotificationRead(
  action: ActionType<typeof actions.updateNotificationReadAction.request>
) {
  try {
    const { data: response }: AxiosResponse<Notification[]> = yield call(
      [client, 'put'],
      '/notifications/read',
      {
        read: action.payload.read ?? true,
        uuid: action.payload.uuid,
      }
    );

    yield put(actions.updateNotificationReadAction.success(response));
  } catch (err: any) {
    const portalError = getPortalError(Error('Issue updating notification'));

    yield put(actions.updateNotificationReadAction.failure(portalError));
  }
}
export function* notificationsSagas() {
  yield takeLatest(
    getType(actions.notificationsRequestAction.request),
    getAllNotifications
  );

  yield takeLatest(
    getType(actions.updateNotificationReadAction.request),
    updateNotificationRead
  );

  // Listen for the start polling action to kick off the race
  yield takeLatest(actions.startPollingNofications, notificationWatchWorker);
}
